<ng-container *ngIf="!contentFilePreview && !isExternal && !readOnly">
  <div
    id="avatar-upload"
    class="uploader-container status"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <div class="uploader-preview-container cursor-pointer">
      <img src="assets/img/upload.jpg" />
      <span class="preview-title">{{ "COMMON.UPLOAD-VIDEO" | translate }}</span>
      <span class="preview-description">.zip/.mp4 (max 4GB)</span>
    </div>

    <div *ngIf="uploadInProgress" class="justify-content-center text-center">
      <p  class="text-danger fw-bold upload-warning-message">
        {{ "FILE-UPLOADER.PLEASE-DO-NOT-CLOSE-THE-TAB" | translate }}
      </p>
    </div>

    <div *ngIf="!readOnly" class="d-flex align-items-center justify-content-center">
        <button mat-flat-button color="primary" (click)="fileInput.click()">Select a file</button>
        <input type="file" #fileInput (change)="onFileChange($event)" style="display: none;">
    </div>

    <div *ngIf="fileUploadStatus" class="mt-1 text-muted d-flex justify-content-center">
      <p>Status : {{ fileUploadStatus }}</p>
    </div>

    <div class="dropzone-info">
      <div class="dropzone-info-text">{{"COMMON.UPLOAD-DRAG-DROP" | translate}}</div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="contentFilePreview">
  <div class="preview-container">
    <div class="preview-image-container">
      <img
        *ngIf="thumbnailUrl$ | async as imagePreviewUrl"
        [src]="imagePreviewUrl | safe:'url'"
        controls
        class="w-100 h-100"
      />
      <img
        *ngIf="!(thumbnailUrl$ | async)"
        [src]="null"
        controls
        class="w-100 h-100"
        appTrainingImageFallback
      />
    </div>
    <div class="buttons-overlay" *ngIf="!readOnly">
      <dx-button
        *ngIf="!isRemoveOptionHidden"
        [text]="(contentFilePreview.contentType == CourseContentTypeModel.AzureVideo 
          ? 'FILE-UPLOADER.REMOVE-VIDEO' : 'FILE-UPLOADER.REMOVE-SCORM') | translate"
        type="danger"
        stylingMode="contained"
        (onClick)="onContentDeleteClick()"
      ></dx-button>

      <dx-button 
        id="upload-trigger-button"
        [text]="'FILE-UPLOADER.UPLOAD-ALTERNATIVE-PREVIEW-IMAGE' | translate"
        type="default"
        stylingMode="contained"
        [visible]="!hasCustomPreviewImage"
      ></dx-button>

      <dx-button
        [text]="'FILE-UPLOADER.DELETE-ALTERNATIVE-PREVIEW-IMAGE' | translate"
        type="danger"
        stylingMode="contained"
        (onClick)="onPreviewImageDeleteClick()"
        [visible]="hasCustomPreviewImage"
      ></dx-button>

      <dx-file-uploader
        #fileUploader
        dialogTrigger="#upload-trigger-button"
        dropZone=".preview-container"
        [multiple]="false"
        accept="image/*"
        uploadMode="instantly"
        [visible]="false"
        (onValueChanged)="onPreviewImageUpload($event)"
      ></dx-file-uploader>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isExternal && !contentFile">
  <div class="external-preview-container">
    <img
      *ngIf="thumbnailUrl$ | async as imagePreviewUrl"
      [src]="imagePreviewUrl | safe:'url'"
      controls
      class="w-100 h-100"
    />
  </div>
</ng-container>
